import userClient from '../config/api/userClient';
var getReportTypesUrl = "reporttypes";
var getFilterableFieldsUrl = "reports/filterableFields";
var getReportTypeDataUrl = "reports";
var getReportTypeDataByPublisherUrl = "reports/publisherIds";
var stackedBarChartUrl = "reports/stackedchart";
var stackedBarChartByPublisherUrl = "reports/publisherIds/stackedchart";
var getPlatformsUrl = "platforms";
var getPlatformGroupsUrl = "platformGroups";
var getReportGroupsUrl = "reportgroups";
var getPubdeskInventoriesUrl = "inventories/search";
var getPlatformInventoriesUrl = "inventoryPlatform/search";
var getAllPlatformsUrl = "platformGroups/allplatform";
var exportCSVUrl = "reports/exportallcsv/";
var getAllPlatformGroupUrl = "platformGroups/platformGroupIncludePlatforms";
var getPlatformByPublisherURL = "platforms/relatesToPublisher";
var previewReportTypeUrl = "reports/previewReport";
var previewReportTypeStackUrl = "reports/previewReportStackedChart";
var requiredDimensionUrl = "metrics/requiredDimension";
var reportGroupsOrderUrl = "reportgroups/ordered";
var getOrderedReportGroupsUrl = "reportgroups/ordered";
var composedChartUrl = "reports/composedchart";
var composedChartByPublisherUrl = "reports/publisherIds/composedchart";
var previewReportTypeComposedUrl = "reports/previewReportComposedChart";
var getDeviceCategoryUrl = "reports/trackingPlatformData/filterable";
var defaultSettingUrl = "reportgroups/filter";
var reportJobUrl = "reportJob";
var reportGroupPinUrl = "reportgroups/pin";
var calculateStatus = "reports/calculateStatus";
var scheduleReportUrl = "scheduleReport";
var reportGroupVisibilityUrl = "reportgroups/visibility";
export var getReportTypes = function (params) {
    return userClient.get(getReportTypesUrl, { params: params });
};
export var getReportTypeData = function (params, source) {
    return userClient.get(getReportTypeDataUrl, { params: params, cancelToken: source === null || source === void 0 ? void 0 : source.token });
};
export var getReportTypeDataByPublisher = function (params, source) {
    return userClient.get(getReportTypeDataByPublisherUrl, { params: params, cancelToken: source === null || source === void 0 ? void 0 : source.token });
};
export var getFilterableFields = function (params) {
    return userClient.get(getFilterableFieldsUrl, { params: params });
};
export var getReportTypeById = function (id) {
    return userClient.get(getReportTypesUrl + "/" + id);
};
export var getReportGroups = function (publisherIds, visibility) {
    return userClient.get(getReportGroupsUrl, { params: { publisherIds: publisherIds, visibility: visibility || undefined } });
};
export var getReportGroupsById = function (id) {
    return userClient.get(getReportGroupsUrl + "/" + id);
};
export var getPlatforms = function () {
    return userClient.get(getPlatformsUrl);
};
export var getPlatformsByPublisher = function (publisherId) {
    return userClient.get(getPlatformByPublisherURL + "/" + publisherId);
};
export var getPlatformGroups = function (publisherIds) {
    return userClient.get(getPlatformGroupsUrl, { params: { publisherIds: publisherIds } });
};
export var getPlatformGroupByLevel = function (params) {
    return userClient.get(getPlatformGroupsUrl, { params: params });
};
export var getPlatformGroupDetails = function (platformGroupId) {
    return userClient.get("getPlatformGroupsUrl/" + platformGroupId);
};
export var getAllPlatformGroupByLevel = function (params) {
    return userClient.get(getAllPlatformGroupUrl, { params: params });
};
export var getPlatformInventoriesByPublisher = function (publisherIds) {
    return userClient.get(getPlatformInventoriesUrl, { params: { publisherIds: publisherIds } });
};
export var getPubdeskInventories = function (publisherIds, mediaIds, labelIds) {
    var params = {
        publisherIds: publisherIds,
        mediaIds: mediaIds ? mediaIds : undefined,
        labelIds: labelIds ? labelIds : undefined
    };
    return userClient.get(getPubdeskInventoriesUrl, { params: params });
};
export var createReportGroup = function (body) {
    return userClient.post(getReportGroupsUrl, body);
};
export var updateReportGroup = function (body, id) {
    return userClient.put(getReportGroupsUrl + "/" + id, body);
};
export var createReportType = function (body) {
    return userClient.post(getReportTypesUrl, body);
};
export var updateReportType = function (body, id) {
    return userClient.put(getReportTypesUrl + "/" + id, body);
};
export var getAllPlatforms = function (params) {
    return userClient.get(getAllPlatformsUrl, { params: params });
};
export var exportCSV = function (body) {
    return userClient.post(exportCSVUrl, body);
};
export var requiredDimension = function (params) {
    return userClient.get(requiredDimensionUrl, { params: params });
};
export var previewReportType = function (params) {
    var reportPresentationType = params.reportPresentationType;
    return userClient.post(previewReportTypeUrl, params);
};
export var previewReportStackChart = function (params) {
    var reportPresentationType = params.reportPresentationType;
    return userClient.post(previewReportTypeStackUrl, params);
};
export var getStackedBarChartData = function (body) {
    return userClient.post(stackedBarChartUrl, body);
};
export var getStackedBarChartDataByPublisher = function (body) {
    return userClient.post(stackedBarChartByPublisherUrl, body);
};
export var orderReportGroups = function (body) {
    return userClient.post(reportGroupsOrderUrl, body);
};
export var getOrderedReportGroups = function (params) {
    return userClient.get(getOrderedReportGroupsUrl, { params: params });
};
export var previewReportComposedChart = function (params) {
    var reportPresentationType = params.reportPresentationType;
    return userClient.post(previewReportTypeComposedUrl, params);
};
export var getComposedChartData = function (body) {
    return userClient.post(composedChartUrl, body);
};
export var getComposedChartDataByPublisher = function (body) {
    return userClient.post(composedChartByPublisherUrl, body);
};
export var getDeviceCategory = function (params) {
    return userClient.get(getDeviceCategoryUrl, { params: params });
};
export var updateDefaultSetting = function (data) {
    return userClient.post(defaultSettingUrl, data);
};
export var loadDefaultSetting = function (publisherId, reportGroupId) {
    return userClient.get(defaultSettingUrl, { params: { publisherId: publisherId, reportGroupId: reportGroupId } });
};
export var getReportJob = function (params) {
    return userClient.get(reportJobUrl, { params: params });
};
export var deleteReportJob = function (id) {
    return userClient.delete(reportJobUrl + "/" + id);
};
export var downloadReportJob = function () {
    return userClient.post(reportJobUrl + "/download", {});
};
export var registerBigReportData = function (body) {
    return userClient.post(reportJobUrl + "/register", body);
};
export var pinReportGroups = function (params) {
    return userClient.get(reportGroupPinUrl, { params: params });
};
export var getCalculatedDataStatus = function (params) {
    return userClient.get(calculateStatus, { params: params });
};
export var deleteReportType = function (id) {
    return userClient.delete(getReportTypesUrl + "/" + id);
};
export var getScheduleReport = function (params) {
    return userClient.get(scheduleReportUrl, { params: params });
};
export var createScheduleReport = function (body) {
    return userClient.post(scheduleReportUrl, body);
};
export var getScheduleReportById = function (id) {
    return userClient.get(scheduleReportUrl + "/" + id);
};
export var updateScheduleReport = function (body, id) {
    return userClient.put("" + scheduleReportUrl, body);
};
export var getHiddenReportGroupIds = function () {
    return userClient.get(reportGroupVisibilityUrl);
};
export var updateReportGroupVisibility = function (body) {
    return userClient.post(reportGroupVisibilityUrl + "/hidden", body);
};
export var deleteReportGroupVisibility = function (body) {
    return userClient.delete(reportGroupVisibilityUrl + "/hidden", { data: body });
};
